import { BasicsClass } from '@/common/BasicsClass';

export class MerchantNoticeManageAPI extends BasicsClass {
    public apiUrls: any = new Map([
        ['getMerchantNoticeTableList', {
            url: '/admin/poster/annoucement/list',
            name: 'list',
            label: '公告列表'
        }],
        // ['add', {
        //     url: '/admin/shop/add',
        //     name: 'add',
        //     label: '公告新增',
        //     // hidden: true
        // }],

        // ['edit', {
        //     url: '/admin/shop/update',
        //     name: 'edit',
        //     label: '公告编辑',
        // }],
        ['delete', {
            url: '/admin/poster/annoucement/delete',
            name: 'delete',
            label: '公告删除',
        }],
        // ['getProvince', {
        //     url: '/admin/shop/province',
        //     name: 'province-list',
        //     label: '省份列表（下拉选择）'
        // }],
        // ['getCity', {
        //     url: '/admin/shop/city',
        //     name: 'city-list',
        //     label: '地级市列表（下拉选择）'
        // }],
    ])

    public getMerchantNoticeTableList(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
      const apiUrls = this.apiUrls

      const url = apiUrls.get('getMerchantNoticeTableList').url

      this.BasicPost(url, {
          ...params
      }, false, false, false, successCb, failCb, showLoading)
    }

    // public addMerchantNotice(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
    //     const apiUrls = this.apiUrls

    //     const url = apiUrls.get('add').url

    //     this.BasicPost(url, {
    //         ...params
    //     }, false, false, false, successCb, failCb, showLoading)
    // }

    // public editMerchantNotice(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
    //     const apiUrls = this.apiUrls

    //     const url = apiUrls.get('edit').url

    //     this.BasicPost(url, {
    //         ...params
    //     }, false, false, false, successCb, failCb, showLoading)
    // }

    public delete(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
        const apiUrls = this.apiUrls

        const url = apiUrls.get('delete').url

        this.BasicPost(url, {
            ...params
        }, false, false, false, successCb, failCb, showLoading)
    }

    // public getProvince(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
    //     const apiUrls = this.apiUrls

    //     const url = apiUrls.get('getProvince').url

    //     this.BasicPost(url, {
    //         ...params
    //     }, false, false, false, successCb, failCb, showLoading)
    // }

    // public getCity(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
    //     const apiUrls = this.apiUrls

    //     const url = apiUrls.get('getCity').url

    //     this.BasicPost(url, {
    //         ...params
    //     }, false, false, false, successCb, failCb, showLoading)
    // }

}